import styled from 'styled-components';
import LuggageSvg from '../../assets/amenities/luggage.svg';

const LuggageIcon = styled(LuggageSvg as React.SFC<React.SVGProps<SVGSVGElement>>)`
  width: ${props => props.width || '2.4rem'};
  height: ${props => props.height || '2.4rem'};
  margin: ${props => props.margin};
`;

export default LuggageIcon;
